import React from "react";
import styles from "./Modal.scss";
import close from "../../../assets/images/close-icon.svg";
import classNames from "classnames";

const Modal = ({ onHide }) => (
  <div className={styles.modalcontainer}>
    <img src={close} className={styles.closebutton} onClick={() => onHide()} />
    <div className={styles.modalcontent}>
      <div className={styles.header}>
        <h2 className={styles.title}>How it Works</h2>
      </div>
      <div className={styles.divider}>
        <div className={styles.top} />
        <div className={styles.bottom} />
      </div>
      <div className={styles.intro}>
        The Second Shift connects businesses with a vetted, expert network of
        women who have deep experience in marketing, finance, HR and other
        corporate services. Our members are available on-demand for short-term
        projects, parental leave fill-ins, part-time roles, full-time roles, and
        other flexible work situations.
      </div>
      <div className={styles.content}>
        <div className={styles.row}>
          <div className={styles.numberCircle}>1</div>
          <div className={styles.rowText}>
            <div className={styles.sectiontitle}>Post your project</div>
            <div className={styles.sectioncontent}>
              Find the talent and skills you need, when you need them.
            </div>
            <div className={styles.divider} />
          </div>
        </div>

        <div className={styles.row}>
          <div>
            <div className={styles.numberCircle}>2</div>
          </div>
          <div className={styles.rowText}>
            <div className={styles.sectiontitle}>Matches</div>
            <div className={styles.sectioncontent}>
              We notify members who match your specs with our proprietary
              matching algorithm. We have hundreds of carefully selected, vetted
              and verified members with 10-30 years of specialized experience
              and extensive leadership experience.
            </div>
            <div className={styles.divider} />
          </div>
        </div>

        <div className={styles.row}>
          <div>
            <div className={styles.numberCircle}>3</div>
          </div>
          <div className={styles.rowText}>
            <div className={styles.sectiontitle}>Pitches</div>
            <div className={styles.sectioncontent}>
              Matched, interested members send you proposals. Detailed job
              descriptions with requirements and deliverables garner the most
              relevant pitches.
            </div>
            <div className={styles.divider} />
          </div>
        </div>

        <div className={styles.row}>
          <div>
            <div className={styles.numberCircle}>4</div>
          </div>
          <div className={styles.rowText}>
            <div className={styles.sectiontitle}>Select a member</div>
            <div className={styles.sectioncontent}>
              You select your hire and negotiate and agree to project terms with
              her. You can also select multiple members for your project.
            </div>
            <div className={styles.divider} />
          </div>
        </div>

        <div className={classNames(styles.row, styles.last)}>
          <div>
            <div className={styles.numberCircle}>5</div>
          </div>
          <div className={styles.rowText}>
            <div className={styles.sectiontitle}>
              The Second Shift handles the rest
            </div>
            <div className={styles.sectioncontent}>
              Our members deliver the work. We charge 15% from the employer and
              5% from the member on each invoice after the project has been
              filled.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/modal/Modal.js